export interface OwnersApiResponse<T = undefined> {
  success?: boolean;
  msg?: string;
  data?: T;
}

export type OwnersApiFlag = boolean | 0 | 1;

export const toOwnersBoolean = (value?: OwnersApiFlag): boolean =>
  Boolean(value);

export const isOwnersApiFailure = (res: { success?: boolean }) =>
  res.success === false;

export interface Owner {
  ownerId: number;
  code: string;
  displayName: string;
  email: string | null;
  phone: string | null;
  isActive: OwnersApiFlag;
  trustedKycAutoApprove: OwnersApiFlag;
  kycReviewRequired: OwnersApiFlag;
  createdAt: string;
}

export interface OwnersListData {
  owners: Owner[];
}

export interface CreateOwnerRequest {
  code: string;
  displayName: string;
  email?: string;
  phone?: string;
  trustedKycAutoApprove?: boolean;
  kycReviewRequired?: boolean;
}

export interface CreateOwnerData {
  ownerId: number;
  code: string;
  displayName: string;
  email: string | null;
  phone: string | null;
}

export interface UpdateOwnerContactRequest {
  ownerId: number;
  email?: string;
  phone?: string;
}

export interface OwnerApiKey {
  ownerApiKeyId: number;
  ownerId: number;
  label: string;
  isActive: OwnersApiFlag;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface OwnerApiKeysListData {
  apiKeys: OwnerApiKey[];
}

export interface RevokeOwnerApiKeyRequest {
  ownerApiKeyId: number;
}

export interface OwnerIpWhitelistEntry {
  id: number;
  ownerId: number;
  address: string;
  partnerMerchantId?: number | null;
  label?: string | null;
  active: OwnersApiFlag;
  createdBy: string;
  createdAt: string;
  updatedAt?: string;
}

export interface OwnerIpWhitelistListData {
  entries: OwnerIpWhitelistEntry[];
}

export interface AddOwnerIpWhitelistRequest {
  ownerId: number;
  address: string;
  partnerMerchantId?: number;
  label?: string;
}

export interface ToggleOwnerIpWhitelistRequest {
  id: number;
  active: boolean;
}

export interface DeleteOwnerIpWhitelistRequest {
  id: number;
}
